module.exports = __webpack_public_path__ + "static/media/card-placeholder-white.7ec9fad8.svg";